import { render } from "./AddToAlbumModal.vue?vue&type=template&id=51c0dd8a&scoped=true&ts=true"
import script from "./AddToAlbumModal.vue?vue&type=script&lang=ts"
export * from "./AddToAlbumModal.vue?vue&type=script&lang=ts"

import "./AddToAlbumModal.vue?vue&type=style&index=0&id=51c0dd8a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51c0dd8a"]])

export default __exports__